import React from "react";

function StatsSection() {
  const stats = [
    {
      value: "+10.000",
      label: "advogados e equipes ativas",
      detail: "operacao juridica com escala e padrao",
    },
    {
      value: "+2 milhoes",
      label: "processos e movimentacoes",
      detail: "gestao centralizada com acompanhamento continuo",
    },
    {
      value: "99,9%",
      label: "disponibilidade da plataforma",
      detail: "acesso confiavel para a rotina do escritorio",
    },
    {
      value: "24/7",
      label: "visao do negocio em nuvem",
      detail: "trabalho de qualquer lugar com fluidez",
    },
  ];

  return (
    <section className="presentation-section presentation-section-soft">
      <div className="container presentation-shell px-4 px-lg-5 py-5 position-relative z-1">
        <div className="stats-wrapper">
          <div className="section-intro mb-5">
            <span className="section-kicker">Resultados</span>
            <h2 className="section-title mb-3">Prova social com foco em confianca</h2>
            <p className="section-description section-description-muted">
              O layout da home agora sustenta melhor a percepcao de robustez do
              produto e comunica valor logo nas primeiras dobras da pagina.
            </p>
          </div>

          <div className="row g-4 justify-content-center text-start">
            {stats.map((stat, index) => (
              <div key={index} className="col-12 col-sm-6 col-xl-3">
                <article className="stats-card h-100">
                  <h3 className="stats-value">{stat.value}</h3>
                  <p className="stats-label">{stat.label}</p>
                  <span className="stats-detail">{stat.detail}</span>
                </article>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default StatsSection;
